import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { BookingService } from 'app/services/booking.service';
import { WidgetSearchComponent } from 'app/common/widget-search/widget-search.component';
import { DatePickerComponent } from 'app/common/date-picker/date-picker.component';
import { GuestSelectionComponent } from './guest-selection/guest-selection.component';

@Component({
  selector: 'booking-widget',
  templateUrl: './booking-widget.component.html',
})
export class BookingWidgetComponent implements OnInit {
  public bookingWidgetLabels: any = {
    bookingCode: {
      label: "",
      tooltip: "",
      rememberLabel: "",
      errorMsg: ""
    },
    codeRewardsNights: {
      mobile: "",
      desktop: ["", "", "", ""],
    },
    datepicker: {
      label: "",
    },
    guestSelector: {
      label: "",
    },
    redemption: {
      errorMsg: "",
      label: "",
      tooltip: "",
    },
    voucher: {
      label: "",
      tooltip: "",
    }
  }
  public bookingData = {
    bookingCode: {
      value: "",
      remember: false,
      valid: true,
      isVoucher: false,
    },
    roomCount: 1,
    redemption: false,
    voucher: false,
    validSearch: false,
    validGuest: false,
  };
  public showBookingOptions = false;
  public validForm = false;
  public submitForm = false;
  public modifyDate = false;
  public hotelPage = false;
  public showGuestSelection = true;
  public hideOffers = true;
  forceShowOption: string;

  @ViewChild('bookingCodeInput') bookingCodeEle: ElementRef;
  @ViewChild('root') rootEle: ElementRef;
  @ViewChild('widgetSearchComp') widgetSearchComp: WidgetSearchComponent;
  @ViewChild('datePickerComp') datePickerComp: DatePickerComponent;
  @ViewChild('guestSelectionComp') guestSelectionComp: GuestSelectionComponent;

  constructor(private elementRef: ElementRef, private bookingService: BookingService) {
    if (typeof (document) != 'undefined') {
      document.body.classList.add('ng-ready');
    }
    if (!window["Scandic"]) { window["Scandic"] = {}; }
    if (document.querySelector("#bw-labels")) {
      window["Scandic"].bookingWidgetLabels = JSON.parse(document.querySelector("#bw-labels").textContent.toString());
    }
    if (document.querySelector("#bw-data")) {
      window["Scandic"].bookingWidgetData = JSON.parse(document.querySelector("#bw-data").textContent.toString());
    }
    this.modifyDate = this.elementRef.nativeElement.getAttribute('modify-date') || false;
    this.hotelPage = this.elementRef.nativeElement.getAttribute('hotel-page') || false;
  }

  ngOnInit() {
    if (typeof (window) == 'undefined') {
      return;
    }
    this.bookingWidgetLabels = window['Scandic'].bookingWidgetLabels;
    if (this.bookingService.getSearchData('options')) {
      this.bookingData = this.bookingService.getSearchData('options');
    }
    if (this.bookingService.getSavedBookingCode()) {
      this.bookingData.bookingCode = this.bookingService.getSavedBookingCode();
    }
    const bookingData = window['Scandic'].bookingWidgetData;
    if (bookingData) {
      if (bookingData.bookingCode.value) {
        this.resetOptions(null, "bookingCode", "init");
        this.bookingData.bookingCode.value = bookingData.bookingCode.value;
      } else if (bookingData.redemption) {
        this.resetOptions(null, "redemption", "init");
        this.bookingData.redemption = !!bookingData.redemption;
      } else if (bookingData.voucher) {
        this.resetOptions(null, "voucher", "init");
        this.bookingData.voucher = !!bookingData.voucher;
      }
    }
    const currentUrl = decodeURIComponent(window.location.href).toLowerCase();
    if ((currentUrl.indexOf("fromdate") != -1 && currentUrl.indexOf("todate") != -1) || (currentUrl.indexOf("room[0].adults") != -1)) {
      this.bookingData.bookingCode.value = bookingData.bookingCode.value;
      this.bookingData.redemption = !!bookingData.redemption;
      this.bookingData.voucher = !!bookingData.voucher;
    }

    if (currentUrl.indexOf("?hotel") != -1 && currentUrl.indexOf("fromdate") == -1 && currentUrl.indexOf("room[0].adults") == -1 && (!this.bookingData.bookingCode.remember || window.location.pathname !== '/')) {
      this.bookingData.bookingCode = {
        value: "",
        remember: false,
        valid: true,
        isVoucher: false,
      };
      this.bookingData.redemption = false;
      this.bookingData.voucher = false;
    }

    if (this.bookingData.bookingCode.value.toLowerCase() == "fg2" || this.bookingData.bookingCode.value.toLowerCase() == "fg1" || this.bookingData.bookingCode.value.toLowerCase() == "xxx") {
      this.bookingData.bookingCode.value = "";
    }
    this.updateForceShowOption();
    this.validateBookingCode();

    if ('performance' in window && window.performance.mark !== undefined) {
      window.performance.mark("bookingWidgetReady");
    }

    if (window["datalayer"][0].pagetype.indexOf("offer") != -1 && window["datalayer"][0].pagetype.indexOf("hoteloffers") == -1) {
      this.stickyBW();
    }

    window.addEventListener('pageshow', function ( event ) {
      var historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
      if ( historyTraversal && this.submitForm ) {
        location.reload();
      }
    }.bind(this));
  }

  clearCode() {
    this.bookingData.bookingCode.value = "";
    this.bookingCodeEle.nativeElement.focus();
    this.validateBookingCode();
    this.reValidateBookingWidget(null, "bookingCode");
    this.bookingDataChanged();
  }

  updateForceShowOption(): void {
    if (this.bookingData.bookingCode.value) {
      this.forceShowOption = "bookingCode";
    } else if (this.bookingData.redemption) {
      this.forceShowOption = "redemption";
    } else if (this.bookingData.voucher) {
      this.forceShowOption = "voucher";
    } else {
      this.forceShowOption = null;
    }
  }

  toggleBookingCode(state?: boolean, noFocus?: boolean): void {
    noFocus = !!noFocus;
    this.updateForceShowOption();
    if (state != undefined || state != null) {
      this.showBookingOptions = state ? true : false;
    } else {
      this.showBookingOptions = !this.showBookingOptions;
    }
    if (!noFocus && this.showBookingOptions && !this.bookingData.redemption && !this.bookingData.voucher) {
      // Wait till the element is displayed on DOM and available to trigger focus
      setTimeout(function () {
        this.bookingCodeEle.nativeElement.focus();
      }.bind(this), 100);
    }
  }

  validateBookingCode(): void {
    this.bookingData.bookingCode.isVoucher = false;
    this.hideOffers = !this.bookingData.bookingCode.value;
    if (!this.bookingData.bookingCode.value) {
      this.bookingData.bookingCode.valid = true;
      return;
    }

    if (this.bookingData.bookingCode.value.toLowerCase() === "xxx") {
      this.bookingData.bookingCode.valid = false;
      return;
    }

    let bookingCode = this.bookingData.bookingCode.value;

    let valid = true;
    if (/^D/i.test(bookingCode)) {
      // If "D" code then check validity for "D" and "DSH" codes
      // "D" followed by numbers only & "DSH" followed by alphanumerics
      valid = /^D\d*$/i.test(bookingCode) || /^DSH[0-9a-z]*$/i.test(bookingCode);
    } else if (/^L/i.test(bookingCode)) {
      // If "L" code then check validity for L and LH codes
      // "L" followed by numbers only & "LH" followed by alphanumerics
      valid = /^L\d*$/i.test(bookingCode) || /^LH[0-9a-z]*$/i.test(bookingCode);
    } else if (/^B/i.test(bookingCode)) {
      // If "B" code then check validity as "B" + three letters + six numbers
      valid = /^B[a-z]{3}\d{6}/i.test(bookingCode);
    } else if (/^VO/i.test(bookingCode)) {
      //  If "VO" voucher code then check validity as code starts with VO (case-insensitive)
      valid = /^VO[0-9a-z]*$/i.test(bookingCode);
      this.bookingData.bookingCode.isVoucher = true;
    } else {
      valid = /^[0-9a-z]*$/i.test(bookingCode);
    }

    this.bookingData.bookingCode.valid = valid;
  }

  resetOptions(e: any, noChange: string, isInit?: string) {
    if (e && e.type == "keyup" && e.which == 9)
      return; // return if traversing through widget fields

    if (noChange != "bookingCode") {
      this.bookingData.bookingCode.value = "";
      this.bookingData.bookingCode.isVoucher = false;
      this.bookingData.bookingCode.valid = true;
      this.bookingData.bookingCode.remember = false;
    }
    this.bookingData.redemption = noChange == "redemption" ? this.bookingData.redemption : false;
    this.bookingData.voucher = noChange == "voucher" ? this.bookingData.voucher : false;

    if (noChange == "redemption") {
      this.reValidateBookingWidget(null, "redemption");
    } else if (noChange == "bookingCode") {
      this.validateBookingCode();
      this.reValidateBookingWidget(null, "bookingCode");
    } else {
      this.bookingData.validGuest = true;
    }

    if (!isInit)
      this.bookingDataChanged();
    this.hideOffers = !this.bookingData.bookingCode.value;
  }

  reValidateBookingWidget(data, field) {
    if (field == "widget-search") {
      this.bookingData.validSearch = data.valid;
    } else if (field == "guest-selection") {
      this.bookingData.validGuest = data.valid;
      this.bookingData.roomCount = data.roomCount;
      if (this.bookingData.bookingCode.isVoucher) {
        this.validateBookingCode();
        this.reValidateBookingWidget(null, "bookingCode");
      }
    } else if (field == "redemption" && !this.bookingData.redemption && this.bookingData.roomCount > 1) {
      this.bookingData.validGuest = false;
    } else if (field == "redemption" && this.bookingData.redemption) {
      this.bookingData.validGuest = true;
    } else if (field == "bookingCode" && this.bookingData.bookingCode.isVoucher && this.bookingData.roomCount > 1) {
      this.bookingData.validGuest = false;
      this.bookingData.bookingCode.valid = false;
    } else if (field == "bookingCode" && !this.bookingData.bookingCode.isVoucher) {
      this.bookingData.validGuest = true;
    }
  }

  validateBookingWidget() {
    if (!this.bookingData.validSearch || !this.bookingData.validGuest || !this.bookingData.bookingCode.valid)
      this.validForm = false;
    else
      this.validForm = true;

    if (!this.bookingData.validSearch) {
      this.widgetSearchComp.isEmpty = !this.widgetSearchComp.noMatch ? true : false;
      document.getElementById('widget-search__text').focus();
      // iPhone scroll issue fix
      if (navigator.userAgent.indexOf("iPhone") != -1 || navigator.userAgent.indexOf("iPad") != -1) {
        window.scrollTo(0, 0);
      }
      document.getElementById('widget-search__text').dispatchEvent(new Event("keyup"));
    } else if (!this.bookingData.bookingCode.valid) {
      this.bookingCodeEle.nativeElement.focus();
    } else if (!this.bookingData.validGuest && document.querySelector(".child-age-invalid")) {
      const invalidElem = <any>document.querySelector(".child-age-invalid");
      invalidElem.focus();
    }
  }

  onSubmitBookingWidget(e) {
    if (this.modifyDate) {
      this.submitForm = true;
      setTimeout(function () {
        this.rootEle.nativeElement.parentElement.parentElement.submit();
      }.bind(this), 300);
      return;
    }

    // For browsers to validate widget after closing datepicker and guests modal.
    setTimeout(function () {
      this.validateBookingWidget();

      if (this.validForm) {
        this.submitForm = true;
        // For IE browsers add delay to show dots and button effects
        setTimeout(function () {
          this.widgetSearchComp.saveSearchData();
          this.datePickerComp.saveSearchData();
          this.guestSelectionComp.saveSearchData();
          this.saveSearchData();

          this.rootEle.nativeElement.parentElement.parentElement.submit();
        }.bind(this), 300);
      }
    }.bind(this), 300);

    return this.validForm;
  }

  saveSearchData(): void {
    if (!this.bookingData.bookingCode.value) {
      this.bookingData.bookingCode.remember = false;
    }
    this.bookingService.saveSearchData(this.bookingData, 'options');

    if (this.bookingData.bookingCode.remember) {
      this.bookingService.setSavedBookingCode(this.bookingData.bookingCode);
    } else {
      this.bookingService.setSavedBookingCode(false);
    }
  }

  // Grayout function
  bookingDataChanged(): void {
    // update booking widget submit button to orange
    Array.from(document.querySelectorAll(".booking-widget__btn"), (elem) => {
      elem.classList.add("btn-booking-widget-alert");
    });
    Array.from(document.querySelectorAll(".booking__selection a, .booking__selection input, .booking__selection button"), (elem) => {
      elem.removeAttribute("href");
      elem.setAttribute('disabled', "disabled");
    });
    Array.from(document.querySelectorAll(`
      .heading-with-filter-controls__inner-container h1, .filter-and-distance-controls select, #sort-order[data-disable-on-widget-update]
      `,
    ), (elem: any) => {
      elem.setAttribute("style", "opacity: 0.45;cursor: not-allowed");
    });
    Array.from(document.querySelectorAll(`
      .filter-and-distance-controls a,
      .filter-and-distance-controls button,
      .filter-and-distance-controls input,
      .filter-and-distance-controls select,
      .map-destinations-list__destination a,
      .map-destinations-list__destination button,
      .map-destinations-list__destination input,
      .map-destinations-list__destination select,
      .map-destinations-list__destination [tabindex],
      #sort-order[data-disable-on-widget-update]
      `,
    ), (elem: any) => {
      elem.setAttribute('tabindex', -1);
      elem.disabled = true;
    });
    Array.from(document.querySelectorAll("[data-disable-on-widget-update]"), (disableElem) => {
      disableElem.classList.add("is-disabled-after-update");
    });
  }

  /**
   * Sticky booking widget on offers page
   */
  stickyBW(): void {
    if (window.innerWidth < 940)
      return;

    var bookingWidgetTop = document.querySelector(".booking-widget-wrapper")["offsetTop"];
    var BWElem = document.querySelector(".booking-widget-wrapper");
    var isBWSticky = false;
    var selfBW = this;
    let expandStickyBW = function () {
      if (BWElem.classList.contains("l-booking-widget--compact")) {
        BWElem.classList.remove("l-booking-widget--compact");
        BWElem.classList.add("l-booking-widget--expanded");
        selfBW.toggleBookingCode(true, true);
      }
    };
    let collapseStickyBW = function (e) {
      if (!BWElem.contains(e.target) && BWElem.classList.contains("l-booking-widget--sticky")) {
        BWElem.classList.add("l-booking-widget--compact");
        BWElem.classList.remove("l-booking-widget--expanded");
        selfBW.toggleBookingCode(false);
      }
    };
    let stickyBW = function () {
      if (window.pageYOffset > bookingWidgetTop && !isBWSticky) {
        isBWSticky = true;
        BWElem.classList.add("l-booking-widget--sticky");
        if (!BWElem.classList.contains("l-booking-widget--expanded")) {
          BWElem.classList.add("l-booking-widget--compact");
        }
        if (!document.querySelector(".hero-fixed .hero")) {
          document.querySelector("main.l-sections-wrapper")["style"].paddingTop = BWElem["offsetHeight"] + "px";
        }
        BWElem.addEventListener("click", expandStickyBW);
        document.addEventListener("click", collapseStickyBW, true);
      } else if (window.pageYOffset <= bookingWidgetTop && isBWSticky) {
        isBWSticky = false;
        if (!document.querySelector(".hero-fixed .hero")) {
          document.querySelector("main.l-sections-wrapper")["style"].paddingTop = "0";
        }
        BWElem.classList.remove("l-booking-widget--sticky");
        BWElem.removeEventListener("click", expandStickyBW);
        document.removeEventListener("click", collapseStickyBW, true);
      }
    };
    window.addEventListener("scroll", stickyBW);
  }
}
